import { Component, OnInit } from '@angular/core';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AuthenticationResult, EventMessage, EventType } from '@azure/msal-browser';
import { UserService } from './services/user.service';
import { Subject, takeUntil } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';

/**
 * Application bootstrap component.
 */
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  public isIframe = false;
  private readonly _destroying$ = new Subject<void>();

  /**
   * Creates an instance of component.
   * 
   * @param msalService MSAL service.
   * @param msalBroadcastService MSAL event broker service.
   * @param userService User service.
   */
  constructor(
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private userService: UserService) { }

  /**
   * Initializes component.
   */
  ngOnInit() {
    this.isIframe = window !== window.parent && !window.opener;

    this.msalBroadcastService.msalSubject$.pipe(
      filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS),
      takeUntil(this._destroying$),
      tap((result: EventMessage) => {
        const payload = result.payload as AuthenticationResult;
        this.msalService.instance.setActiveAccount(payload.account);
      }),
      switchMap(_ => this.userService.login())
    ).subscribe();
  }

  /**
   * Frees component resources.
   */
  ngOnDestroy() {
    this._destroying$.next(null!);
    this._destroying$.complete();
  }
}
